import { onMounted } from 'vue';
import { useSeonApi } from '../../../../api/seon-api';
import Cookie from 'js-cookie';
import { COOKIE_PORTAL_ID_NAME } from '../../constants/constants';

const portalIdSanitized = Cookie.get(COOKIE_PORTAL_ID_NAME)?.replace(/-/g, '');

const { getSession: getExtendedSession, postSession } = useSeonApi(portalIdSanitized);

const setConfig = () => {
	if (portalIdSanitized) {
		window.seon.config({
			session_id: portalIdSanitized,
			audio_fingerprint: true,
			canvas_fingerprint: true,
			webgl_fingerprint: true,
			onSuccess: (msg) => console.log(msg),
			onError: (msg) => console.error(msg)
		});
	}
};

const getSession = async () => {
	try {
		let session = await window.seon.getBase64Session();
		if (session) {
			try {
				await postSession(session);
				const { data } = await getExtendedSession();
				return data;
			} catch (error) {
				console.error('Error fetching extended session:', error);
				return session;
			}
		}
	} catch (error) {
		console.error('Error fetching base64 session:', error);
	}
	return null;
};

export const useSeon = () => {
	onMounted(() => {
		setConfig();
	});

	return {
		getSession
	};
};